// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdownppl-dropdown {
  display: none;
  background: white;
  width: 25rem;
  max-height: 10rem;
  border: 1px solid lightgray;
  border-top: none;
  overflow-y: auto;
  z-index: 1;
}

.dropdownppl-container ods-autosuggest {
  width: 100%;
}
.dropdownppl-container ods-autosuggest ::ng-deep input {
  border: 1px solid var(--ods-color-gray-40) !important;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  background-color: white;
}
.dropdownppl-container ods-autosuggest ::ng-deep input:focus {
  border-color: var(--ods-color-purple-60) !important;
  outline: none;
  box-shadow: 0 0 0 2px var(--ods-color-purple-10);
}
.dropdownppl-container ods-autosuggest ::ng-deep input::placeholder {
  color: var(--ods-color-gray-40);
}
.dropdownppl-container orchid-text-input-mask {
  overflow: hidden;
  width: min-content;
}
.dropdownppl-container orchid-text-input-mask ::ng-deep input::placeholder {
  color: var(--ods-color-gray-30);
}
.dropdownppl-container orchid-text-input-mask ::ng-deep span {
  margin-top: 0.478rem;
}

.dropdown-ul {
  padding: 0;
}

.dropdown-li {
  padding: 0.5rem 1rem;
  list-style: none;
  color: var(--ods-color-gray-70);
  font-family: monospace;
  font-size: 0.9rem;
}

.dropdown-li:hover {
  background-color: var(--ods-color-purple-20);
}

.show {
  position: absolute;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/ep-dropdown/ep-dropdown.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;AACF;;AAGE;EACE,WAAA;AAAJ;AAGM;EACE,qDAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,uBAAA;AADR;AAGQ;EACE,mDAAA;EACA,aAAA;EACA,gDAAA;AADV;AAIQ;EACE,+BAAA;AAFV;AAQE;EACE,gBAAA;EACA,kBAAA;AANJ;AASM;EACE,+BAAA;AAPR;AASM;EACE,oBAAA;AAPR;;AAaA;EACE,UAAA;AAVF;;AAaA;EACE,oBAAA;EACA,gBAAA;EACA,+BAAA;EACA,sBAAA;EACA,iBAAA;AAVF;;AAaA;EACE,4CAAA;AAVF;;AAaA;EACE,kBAAA;EACA,cAAA;AAVF","sourcesContent":[".dropdownppl-dropdown {\n  display: none;\n  background: white;\n  width: 25rem;\n  max-height: 10rem; // according to content change size\n  border: 1px solid lightgray;\n  border-top: none;\n  overflow-y: auto;\n  z-index: 1;\n}\n\n.dropdownppl-container {\n  ods-autosuggest {\n    width: 100%;\n\n    ::ng-deep {\n      input {\n        border: 1px solid var(--ods-color-gray-40) !important;\n        border-radius: 4px;\n        padding: 0.5rem 1rem;\n        font-size: 1rem;\n        background-color: white;\n\n        &:focus {\n          border-color: var(--ods-color-purple-60) !important;\n          outline: none;\n          box-shadow: 0 0 0 2px var(--ods-color-purple-10);\n        }\n\n        &::placeholder {\n          color: var(--ods-color-gray-40);\n        }\n      }\n    }\n  }\n\n  orchid-text-input-mask {\n    overflow: hidden;\n    width: min-content;\n\n    ::ng-deep {\n      input::placeholder {\n        color: var(--ods-color-gray-30);\n      }\n      span {\n        margin-top: 0.478rem;\n      }\n    }\n  }\n}\n\n.dropdown-ul {\n  padding: 0;\n}\n\n.dropdown-li {\n  padding: 0.5rem 1rem;\n  list-style: none;\n  color: var(--ods-color-gray-70);\n  font-family: monospace;\n  font-size: 0.9rem;\n}\n\n.dropdown-li:hover {\n  background-color: var(--ods-color-purple-20);\n}\n\n.show {\n  position: absolute;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
